export default __webpack_public_path__ + "static/media/one.e57be48e.jpeg";